"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../../../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            position: 'absolute',
            right: spacing(3.5)
        }
    });
});
exports.default = useStyles;
